/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_View_TableInputs */

const en_admin_ai_chat_view_table = /** @type {(inputs: Admin_Ai_Chat_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table`)
};

const de_admin_ai_chat_view_table = /** @type {(inputs: Admin_Ai_Chat_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabelle`)
};

const es_admin_ai_chat_view_table = /** @type {(inputs: Admin_Ai_Chat_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabla`)
};

const fr_admin_ai_chat_view_table = /** @type {(inputs: Admin_Ai_Chat_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau`)
};

const nl_admin_ai_chat_view_table = /** @type {(inputs: Admin_Ai_Chat_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabel`)
};

/** @type {(inputs: Admin_Ai_Chat_View_TableInputs) => LocalizedString} */
const it_admin_ai_chat_view_table = en_admin_ai_chat_view_table;

/** @type {(inputs: Admin_Ai_Chat_View_TableInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_view_table = en_admin_ai_chat_view_table;

/** @type {(inputs: Admin_Ai_Chat_View_TableInputs) => LocalizedString} */
const pl_admin_ai_chat_view_table = en_admin_ai_chat_view_table;

/** @type {(inputs: Admin_Ai_Chat_View_TableInputs) => LocalizedString} */
const hu_admin_ai_chat_view_table = en_admin_ai_chat_view_table;

/** @type {(inputs: Admin_Ai_Chat_View_TableInputs) => LocalizedString} */
const ro_admin_ai_chat_view_table = en_admin_ai_chat_view_table;

/**
* | output |
* | --- |
* | "Table" |
*
* @param {Admin_Ai_Chat_View_TableInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_view_table = /** @type {((inputs?: Admin_Ai_Chat_View_TableInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_View_TableInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_view_table(inputs)
	if (locale === "de") return de_admin_ai_chat_view_table(inputs)
	if (locale === "es") return es_admin_ai_chat_view_table(inputs)
	if (locale === "fr") return fr_admin_ai_chat_view_table(inputs)
	if (locale === "nl") return nl_admin_ai_chat_view_table(inputs)
	if (locale === "it") return it_admin_ai_chat_view_table(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_view_table(inputs)
	if (locale === "pl") return pl_admin_ai_chat_view_table(inputs)
	if (locale === "hu") return hu_admin_ai_chat_view_table(inputs)
	return ro_admin_ai_chat_view_table(inputs)
});
export { admin_ai_chat_view_table as "admin.ai_chat.view_table" }